<template>
  <!-- Form box -->
  <b-form>
    <p>{{ sensor.description }}</p>
    <div class="groupBox">
      <!-- Fila 1 -->
      <b-row>
        <b-col>
          <form-input
            v-model="numeroMuestras"
            label="Número de muestras a ser procesadas"
            v-bind:required="true"
          />
        </b-col>
        <b-col>
          <form-input
            v-model="frecuenciaMuestreo"
            label="Frecuencia de muestreo (Hz)"
            v-bind:required="true"
          />
        </b-col>        
      </b-row>
      <b-row>
        <!--spacer -->
        <b-col>
          <form-input v-model="frecuencia1" label="Frec. 1" v-bind:required="true" />
        </b-col>
        <b-col>
          <form-input v-model="frecuencia2" label="Frec. 2" v-bind:required="true" />
        </b-col>
        <b-col>
          <form-input v-model="frecuencia3" label="Frec. 3" v-bind:required="true" />
        </b-col>
        <b-col>
          <form-input v-model="frecuencia4" label="Frec. 4" v-bind:required="true" />
        </b-col>
        <b-col>
          <form-input v-model="frecuencia5" label="Frec. 5" v-bind:required="true" />
        </b-col>
        <b-col>
          <form-input v-model="frecuencia6" label="Frec. 6" v-bind:required="true" />
        </b-col>
        <b-col>
          <form-input v-model="frecuencia7" label="Frec. 7" v-bind:required="true" />
        </b-col>
        <b-col>
          <form-input v-model="frecuencia8" label="Frec. 8" v-bind:required="true" />
        </b-col>
      </b-row>
    </div>
  </b-form>
  <!-- Form box -->
</template>



<script>
import GroupService from "@/services/GroupService";
import Input from "@/components/common/form/Input";

export default {
  props: ["sensor", "save"],
  watch: {
    save: function (newVal, oldVal) {
      return this.updateConfig(this.sensor._id)
    },
  },
  data() {
    return {
      requestedGroup: null,
      numeroMuestras: 0,
      frecuenciaMuestreo: 0,
      frecuencia1: 0,
      frecuencia2: 0,
      frecuencia3: 0,
      frecuencia4: 0,
      frecuencia5: 0,
      frecuencia6: 0,
      frecuencia7: 0,
      frecuencia8: 0,
    };
  },
  components: {
    "form-input": Input,
  },
  methods: {
    async requestSensorConfig(sensorID) {
      await GroupService.getShmConfigBySensorId(sensorID)
        .then((response) => {
          this.numeroMuestras = response.data.numeroMuestras,
          this.frecuenciaMuestreo = response.data.frecuenciaMuestreo,
          this.frecuencia1 = response.data.referencias.frecuencia1,
          this.frecuencia2 = response.data.referencias.frecuencia2,
          this.frecuencia3 = response.data.referencias.frecuencia3,
          this.frecuencia4 = response.data.referencias.frecuencia4,
          this.frecuencia5 = response.data.referencias.frecuencia5,
          this.frecuencia6 = response.data.referencias.frecuencia6,
          this.frecuencia7 = response.data.referencias.frecuencia7,
          this.frecuencia8 = response.data.referencias.frecuencia8
        })
        .catch((e) => {
          console.log("Error recuperando configuracion SHM del sensor");
          console.log(e);
        });
    },

    async updateConfig(sensorID){
      let data = {
          numeroMuestras: this.numeroMuestras,
          frecuenciaMuestreo: this.frecuenciaMuestreo,
          frecuencia1: this.frecuencia1,
          frecuencia2: this.frecuencia2,
          frecuencia3: this.frecuencia3,
          frecuencia4: this.frecuencia4,
          frecuencia5: this.frecuencia5,
          frecuencia6: this.frecuencia6,
          frecuencia7: this.frecuencia7,
          frecuencia8: this.frecuencia8,
      }
      await GroupService.updateShmConfigBySensorId(sensorID, data)
        .then((response) => {
         this.$notify({
          group: "notificateDiv",
          type: "success",
          title: response.data.message
            ? response.data.message
            : "Actualizacion de configuracion",
          text: response.data.message
            ? ""
            : "Se ha actualizado la configuracion del sensor",
          duration: 3000,
          speed: 1000,
        });         
        })
        .catch((e) => {
          console.log("Error recuperando configuracion SHM del sensor");
          console.log(e);
        });        
    }
  },
  mounted() {
    //El ID del sensor viene como prop
    this.requestSensorConfig(this.sensor._id);
  },
};
</script>


<style scoped>
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
}

.innergroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}

.innergroupBoxAlt {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 10px;
}

.titulo1 {
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}
</style>
